import React, { useContext, useMemo, useState } from 'react';
import { ReactReduxContext } from 'react-redux';
import { useLoader } from '../../../main/utils/LoaderContext';
import './Loader.css';

interface LoaderProps {
  forceVisible?: boolean;
  companyName?: string;
}

const Loader: React.FC<LoaderProps> = ({ forceVisible = false, companyName: fallbackCompanyName }) => {
  const { loading } = useLoader();
  const reduxContext = useContext(ReactReduxContext as React.Context<any>);
  const user = reduxContext?.store?.getState?.()?.user as any;
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const companyName =
    fallbackCompanyName ||
    user?.companyName ||
    user?.CompanyName ||
    user?.role?.companyName ||
    user?.role?.CompanyName ||
    'Loading';
  const style = useMemo(
    () =>
      ({
        '--loader-mx': `${mouse.x}px`,
        '--loader-my': `${mouse.y}px`,
        '--solar-mx': `${mouse.x * 1.8}px`,
        '--solar-my': `${mouse.y * 1.8}px`,
      }) as React.CSSProperties,
    [mouse.x, mouse.y],
  );

  if (!forceVisible && !loading) return null;

  return (
    <div
      className="loaderOverlay"
      style={style}
      onMouseMove={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        setMouse({ x: Math.max(-26, Math.min(26, x / 10)), y: Math.max(-20, Math.min(20, y / 12)) });
      }}
      onMouseLeave={() => setMouse({ x: 0, y: 0 })}
    >
      <div className="loaderGlow loaderGlowA" />
      <div className="loaderGlow loaderGlowB" />

      <div className="loaderCard">
        <div className="loaderGlyph" aria-hidden="true">
          <div className="solarSystem">
            <span className="sunCore" />
            <span className="orbit orbit1">
              <span className="planet planet1" />
            </span>
            <span className="orbit orbit2">
              <span className="planet planet2" />
            </span>
            <span className="orbit orbit3">
              <span className="planet planet3" />
            </span>
            <span className="orbit orbit4">
              <span className="planet planet4" />
            </span>
          </div>
        </div>
        <div className="loaderBrand">{companyName}</div>
        <div className="loaderDots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default Loader;

// return (
//   <div className="fallback-spinner">
//     <div className="loading">
//       <Spinner color="primary" />
//     </div>
//   </div>
// );
